import {Modal} from 'antd';
import React, {FC} from 'react';

import {ReactComponent as CloseIcon} from 'shared/assets/close.svg';
import {TModalComponentInterface} from 'store/slices/modals-slice';

import {List} from '../list';

import './list-modal.less';

interface IFormModalProps extends TModalComponentInterface {
    entityName: string;
}

export const ListModal: FC<IFormModalProps> = ({
    onClose,
    entityName,
}: IFormModalProps) => (
    <Modal
        className="list-modal"
        footer={null}
        visible
        centered
        width={680}
        onCancel={onClose}
        maskClosable={false}
        closeIcon={<CloseIcon className="list-modal__close-icon" />}
    >
        <List
            entityName={entityName}
        />
    </Modal>
);
